import { Injector } from '@angular/core';

export async function lazyLoadCheckoutFacade(injector: Injector) {
  const { CheckoutByStepFacade } = await import('./checkout-by-step.facade');
  return injector.get(CheckoutByStepFacade);
}
